/*
 * massage-intake (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { massageIntakes } from "./massage-intake.schema"

export type MassageIntake = z.infer<typeof selectMassageIntakeSchema>
export const selectMassageIntakeSchema = createSelectSchema(massageIntakes)

export type MassageIntakeFilters = z.infer<typeof massageIntakeFiltersSchema>
export const massageIntakeFiltersSchema = z.object({
	id:          z.string().optional(),
	patientId:   z.string().optional(),
	therapistId: z.string().optional(),
	active:      z.boolean().optional(),
})

export const createMassageIntakeSchema = createInsertSchema(massageIntakes)
	.partial(globalCreateExclude)
export type CreateMassageIntake = z.infer<typeof createMassageIntakeSchema>

export const updateMassageIntakeSchema = createInsertSchema(massageIntakes)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateMassageIntake = z.infer<typeof updateMassageIntakeSchema>
